module.exports = __webpack_public_path__ + "img/sprinkle-21.b5e75d44.webp";